import { Injectable } from '@angular/core';

import { ApiService } from './api.service';
import { CONSTANTS } from '../../constants';

@Injectable({
  providedIn: 'root'
})
export class StrategyService extends ApiService {

  public listStrategies() {
    return this.get(CONSTANTS.API.STRATEGY.GET_STRATEGIES);
  }
  public addStrategy(data: any) {
    return this.post(CONSTANTS.API.STRATEGY.ADD_STRATEGY, data);
  }
  public updateStrategy(data: any) {
    return this.put(CONSTANTS.API.STRATEGY.UPDATE_STRATEGY, data);
  }
  updateStrategyState = (data: any) => {
    return this.put(CONSTANTS.API.STRATEGY.UPDATE_STRATEGY_STATE, data);
  }
  updateStrategyScope = (data: any) => {
    return this.put(CONSTANTS.API.STRATEGY.UPDATE_STRATEGY_SCOPE, data);
  }
  public deleteStrategy(data: any) {
    return this.delete(CONSTANTS.API.STRATEGY.DELETE_STRATEGY, data);
  }
}
